
import axios from 'axios';
// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
    ALL_MSKPOSTURE,
    ADD_MSKPOSTURE,
    MSKPOSTURE_ACTION,
    EDIT_MSKPOSTURE,
    STATUS_MSKPOSTURE,
    DELETE_MSKPOSTURE,
    ALL_SHOULDERPOSTURE,
    ADD_SHOULDERPOSTURE,
    EDIT_SHOULDERPOSTURE,
    STATUS_SHOULDERPOSTURE,
    DELETE_SHOULDERPOSTURE,
    ALL_THORACICPOSTURE,
    ADD_THORACICPOSTURE,
    EDIT_THORACICPOSTURE,
    STATUS_THORACICPOSTURE,
    DELETE_THORACICPOSTURE,
    ALL_LUMBARPOSTURE,
    ADD_LUMBARPOSTURE,
    EDIT_LUMBARPOSTURE,
    STATUS_LUMBARPOSTURE,
    DELETE_LUMBARPOSTURE,
    ALL_PELVISPOSTURE,
    ADD_PELVISPOSTURE,
    EDIT_PELVISPOSTURE,
    STATUS_PELVISPOSTURE,
    DELETE_PELVISPOSTURE,
    ALL_KNEEPOSTURE,
    ADD_KNEEPOSTURE,
    EDIT_KNEEPOSTURE,
    STATUS_KNEEPOSTURE,
    DELETE_KNEEPOSTURE,
    ALL_FEETPOSTURE,
    ADD_FEETPOSTURE,
    EDIT_FEETPOSTURE,
    STATUS_FEETPOSTURE,
    DELETE_FEETPOSTURE,
    ALL_RHYTHMPOSTURE,
    ADD_RHYTHMPOSTURE,
    EDIT_RHYTHMPOSTURE,
    STATUS_RHYTHMPOSTURE,
    DELETE_RHYTHMPOSTURE,
    ALL_ABBREVIATIONPOSTURE,
    ADD_ABBREVIATIONPOSTURE,
    EDIT_ABBREVIATIONPOSTURE,
    STATUS_ABBREVIATIONPOSTURE,
    DELETE_ABBREVIATIONPOSTURE
 } from 'Actions/types';

/**
 * MSK Posture Action
 */

// Head Posture
export const allPostureHead = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getposturehead', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_MSKPOSTURE, payload: allroles });
        });
    }
    

}

export const addPostureHead = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addposturehead', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allPostureHead()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_MSKPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Head not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPostureHead = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editposturehead', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allPostureHead()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_MSKPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPostureHead = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusposturehead', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allPostureHead()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_MSKPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePostureHead = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteposturehead', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allPostureHead()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_MSKPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


// Shoulders Posture
export const allPostureShoulders = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getpostureshoulders', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_SHOULDERPOSTURE, payload: allroles });
        });
    }
    

}

export const addPostureShoulders = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addpostureshoulders', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureShoulders()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_SHOULDERPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Data not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPostureShoulders = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editpostureshoulders', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureShoulders()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_SHOULDERPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPostureShoulders = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statuspostureshoulders', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureShoulders()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_SHOULDERPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePostureShoulders= (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deletepostureshoulders', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureShoulders()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_SHOULDERPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

// Thoracic Posture
export const allPostureThoracic = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getposturethoracic', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_THORACICPOSTURE, payload: allroles });
        });
    }
    

}

export const addPostureThoracic = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addposturethoracic', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureThoracic()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_THORACICPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Data not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPostureThoracic = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editposturethoracic', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureThoracic()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_THORACICPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPostureThoracic = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusposturethoracic', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureThoracic()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_THORACICPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePostureThoracic= (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteposturethoracic', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureThoracic()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_THORACICPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

// Lumbar Posture
export const allPostureLumbar = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getposturelumbar', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_LUMBARPOSTURE, payload: allroles });
        });
    }
    

}

export const addPostureLumbar = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addposturelumbar', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureLumbar()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_LUMBARPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Data not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPostureLumbar = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editposturelumbar', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureLumbar()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_LUMBARPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPostureLumbar = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusposturelumbar', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureLumbar()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_LUMBARPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePostureLumbar= (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteposturelumbar', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureLumbar()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_LUMBARPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

// Pelvis Posture
export const allPosturePelvis = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getposturepelvis', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_PELVISPOSTURE, payload: allroles });
        });
    }
    

}

export const addPosturePelvis = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addposturepelvis', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPosturePelvis()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_PELVISPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Data not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPosturePelvis = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editposturepelvis', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPosturePelvis()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_PELVISPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPosturePelvis = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusposturepelvis', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPosturePelvis()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_PELVISPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePosturePelvis= (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteposturepelvis', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPosturePelvis()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_PELVISPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

// Knee Posture
export const allPostureKnee = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getpostureknee', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_KNEEPOSTURE, payload: allroles });
        });
    }
    

}

export const addPostureKnee = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addpostureknee', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureKnee()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_KNEEPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Data not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPostureKnee = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editpostureknee', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureKnee()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_KNEEPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPostureKnee = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statuspostureknee', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureKnee()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_KNEEPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePostureKnee= (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deletepostureknee', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureKnee()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_KNEEPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


// Feet Posture
export const allPostureFeet = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getposturefeet', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_FEETPOSTURE, payload: allroles });
        });
    }
    

}

export const addPostureFeet = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addposturefeet', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureFeet()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_FEETPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Data not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPostureFeet = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editposturefeet', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureFeet()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_FEETPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPostureFeet = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusposturefeet', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureFeet()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_FEETPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePostureFeet= (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteposturefeet', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureFeet()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_FEETPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

// Rhythm Posture
export const allPostureRhythm = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: MSKPOSTURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getposturerhythm', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_RHYTHMPOSTURE, payload: allroles });
        });
    }
    

}

export const addPostureRhythm = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addposturerhythm', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureRhythm()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_RHYTHMPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Data not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editPostureRhythm = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editposturerhythm', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureRhythm()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_RHYTHMPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusPostureRhythm = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusposturerhythm', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureRhythm()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_RHYTHMPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deletePostureRhythm= (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: MSKPOSTURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteposturerhythm', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allPostureRhythm()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_RHYTHMPOSTURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


// Abbreviation Posture
export const allPostureAbbreviation = () =>{    
    
   return (dispatch) => { 
       dispatch({ type: MSKPOSTURE_ACTION });
       return axios.get(AppConfig.apiurl+'/api/getpostureabbreviation', { headers: AuthHeader.header })         
       .then(response => {             
           const allroles=response.data.data;
           dispatch({ type: ALL_ABBREVIATIONPOSTURE, payload: allroles });
       });
   }
   

}

export const addPostureAbbreviation = (name) => async (dispatch) => {
   
   var payload={
       "name":name
    }
    dispatch({ type: MSKPOSTURE_ACTION });
   axios.post(AppConfig.apiurl+'/api/addpostureabbreviation', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               allPostureAbbreviation()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: ADD_ABBREVIATIONPOSTURE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }else{
           NotificationManager.error('Data not added');
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const editPostureAbbreviation = (name,id) => async (dispatch) => {
   
   var payload={
       "id":id,
       "name":name
    }
    dispatch({ type: MSKPOSTURE_ACTION });
   axios.post(AppConfig.apiurl+'/api/editpostureabbreviation', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               allPostureAbbreviation()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: EDIT_ABBREVIATIONPOSTURE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const statusPostureAbbreviation = (id,status) => async (dispatch) => {
   
   var payload={
       "id":id,
       "status":status
    }
    dispatch({ type: MSKPOSTURE_ACTION });
   axios.post(AppConfig.apiurl+'/api/statuspostureabbreviation', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               allPostureAbbreviation()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: STATUS_ABBREVIATIONPOSTURE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const deletePostureAbbreviation= (id) => async (dispatch) => {
   
   var payload={
       "id":id
    }
    dispatch({ type: MSKPOSTURE_ACTION });
   axios.post(AppConfig.apiurl+'/api/deletepostureabbreviation', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               allPostureAbbreviation()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: DELETE_ABBREVIATIONPOSTURE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}
